export default __webpack_public_path__ + "static/media/section4-background.85640269.jpg";